import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Home from "./components/Home";
import Login from "./components/Login";
import Register from "./components/Register";
import CheckDocument from "./components/CheckDocument";
import ChangePassword from "./components/ChangePassword";
import History from "./components/History";
import Contact from "./components/Contact";
import LeilaoDetalhes from "./components/LeilaoDetalhes";
import MeusLances from "./components/MeusLances";
import Noticias from "./components/Noticias";
import Perfil from "./components/Perfil";
import MinhasFaturas from "./components/MinhasFaturas";
import DetalheFatura from "./components/DetalheFatura";
import WhatsAppButton from "./components/WhatsAppButton";
import PrimeiroAcesso from "./components/PrimeiroAcesso";
import AdminCatalogos from "./components/AdminCatalogos";
import AdminImoveis from "./components/AdminImoveis";
import AdminCompras from "./components/AdminCompras";
import Privacidade from "./components/Privacidade";
import { Toaster } from "./components/ui/sonner";

function App() {
  const [user, setUser] = useState({
    isLoggedIn: false,
    nome: '',
    cpf: '',
    clienteId: null,
    token: '',
    detalhes: {
      id: null,
      nomeCompleto: '',
      cpf: '',
      cnpj: '',
      email: '',
      email2: '',
      endereco: '',
      bairro: '',
      cep: '',
      cidade: '',
      estado: '',
      telefoneResidencial: '',
      telefoneComercial: '',
      celular1: '',
      celular2: '',
      rg: '',
      dataNascimento: '',
      dataCadastro: '',
      mae: '',
      pai: '',
      observacoes: '',
      ativo: '',
      bloqueado: '',
      classificacao: '',
      limiteCredito: '',
      renda: '',
      profissao: '',
      empresa: ''
    }
  });

  // Carrega dados do usuário do localStorage na inicialização
  useEffect(() => {
    const savedUser = localStorage.getItem('knorr_user');
    if (savedUser) {
      try {
        const userData = JSON.parse(savedUser);
        if (userData.isLoggedIn) {
          setUser(userData);
        }
      } catch (error) {
        console.error('Erro ao carregar dados do usuário:', error);
        localStorage.removeItem('knorr_user');
      }
    }
  }, []);

  // Salva dados do usuário no localStorage quando o estado muda
  useEffect(() => {
    if (user.isLoggedIn) {
      localStorage.setItem('knorr_user', JSON.stringify(user));
    } else {
      localStorage.removeItem('knorr_user');
    }
  }, [user]);

  const handleLogin = (userData) => {
    console.log('handleLogin called with:', userData);
    setUser({
      isLoggedIn: true,
      nome: userData.nome,
      cpf: userData.cpf,
      clienteId: userData.clienteId,
      token: userData.token,
      detalhes: userData.detalhes || {
        id: userData.clienteId,
        nomeCompleto: userData.nome,
        cpf: userData.cpf,
        cnpj: '',
        email: '',
        email2: '',
        endereco: '',
        bairro: '',
        cep: '',
        cidade: '',
        estado: '',
        telefoneResidencial: '',
        telefoneComercial: '',
        celular1: '',
        celular2: '',
        rg: '',
        dataNascimento: '',
        dataCadastro: '',
        mae: '',
        pai: '',
        observacoes: '',
        ativo: '',
        bloqueado: '',
        classificacao: '',
        limiteCredito: '',
        renda: '',
        profissao: '',
        empresa: ''
      }
    });
  };

  const handleLogout = () => {
    setUser({
      isLoggedIn: false,
      nome: '',
      cpf: '',
      clienteId: null,
      token: '',
      detalhes: {
        id: null,
        nomeCompleto: '',
        cpf: '',
        cnpj: '',
        email: '',
        email2: '',
        endereco: '',
        bairro: '',
        cep: '',
        cidade: '',
        estado: '',
        telefoneResidencial: '',
        telefoneComercial: '',
        celular1: '',
        celular2: '',
        rg: '',
        dataNascimento: '',
        dataCadastro: '',
        mae: '',
        pai: '',
        observacoes: '',
        ativo: '',
        bloqueado: '',
        classificacao: '',
        limiteCredito: '',
        renda: '',
        profissao: '',
        empresa: ''
      }
    });
    localStorage.removeItem('knorr_user');
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Header user={user} onLogout={handleLogout} />
        <main>
          <Routes>
            <Route 
              path="/" 
              element={<Home user={user} />} 
            />
            <Route 
              path="/login" 
              element={<Login onLogin={handleLogin} />} 
            />
            <Route 
              path="/register" 
              element={<Register />} 
            />
            <Route 
              path="/check-document" 
              element={<CheckDocument />} 
            />
            <Route 
              path="/change-password" 
              element={<ChangePassword />} 
            />
            <Route 
              path="/primeiro-acesso" 
              element={<PrimeiroAcesso />} 
            />
            <Route 
              path="/admin/catalogos" 
              element={<AdminCatalogos user={user} />} 
            />
            <Route 
              path="/admin/imoveis" 
              element={<AdminImoveis user={user} />} 
            />
            <Route 
              path="/admin/compras" 
              element={<AdminCompras user={user} />} 
            />
            <Route 
              path="/history" 
              element={<History />} 
            />
            <Route 
              path="/contact" 
              element={<Contact />} 
            />
            <Route 
              path="/meus-lances" 
              element={<MeusLances user={user} />} 
            />
            <Route 
              path="/noticias" 
              element={<Noticias />} 
            />
            <Route 
              path="/perfil" 
              element={<Perfil user={user} />} 
            />
            <Route 
              path="/faturas" 
              element={<MinhasFaturas user={user} />} 
            />
            <Route 
              path="/faturas/:leilaoId" 
              element={<DetalheFatura user={user} />} 
            />
            <Route 
              path="/leilao/:id" 
              element={<LeilaoDetalhes user={user} />} 
            />
            <Route 
              path="/privacidade" 
              element={<Privacidade />} 
            />
          </Routes>
        </main>
        <WhatsAppButton />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;